module.exports = __webpack_public_path__ + "static/img/ser1.f0588f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/ser1.png
// module id = AS5a
// module chunks = 1